import axios from 'axios'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
import router from '../router'
//  http://47.93.189.238:8081/api
//http://192.168.1.194:8081/api
// 创建axios实例
axios.defaults.withCredentials = false
const service = axios.create({
  timeout: 50000, // 请求超时时间
  // baseURL: `http://47.93.189.238:8081/api` // ?TODO 根据部署环境修改域名
  // baseURL: `http://192.168.1.106:8081/api` // ?TODO 根据部署环境修改域名
  baseURL: `https://api.gcphr.cn/api`         // ?TODO 根据部署环境修改域名
})
// request拦截器
service.interceptors.request.use(config => {
  const token = Cookies.get('token');
  token ? config.headers.Authentication = token : null;
  if (!config.headers['Content-Type']) { 
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
  }
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(response => {
  let result;
if (response.data.code == "10001" || response.data.code == "00001" || response.data.code == "00002" || response.data.code == "00003") {
    
    router.push('/')
    Message.error('请重新登录');
}else {
    result = response
}
  //  alert(response);
  // if (response.status !== 200) {
  //   // TODO: 不同状态码返回不同提示Message.error(), +抛错
  //   Message.error(response.data.message)
  //   // eslint-disable-next-line prefer-promise-reject-errors
  //   result = Promise.reject()
  // } else if (response.data.status) {
  //   // TODO: +抛错
  //   if (response.data.status === 1004) {
  //     location.href = location.href.replace(/#.+/, '') + '#/login'
  //   } else if (response.data.code == "10001") {
  //     Message.error('token过期，请重新刷新页面');
  //     router.push('/')
  //   } else if (response.data.state === 1003) {
  //     location.href = location.href.replace(/#.+/, '')
  //   } else if (response.data.message) {
  //     Message.error(response.data.message)
  //   }
  //   // result = Promise.reject(response)
  //   result = Promise.reject(response.data)
  // } else {
  //   result = response
  //   // result = response.data.data
  // }
  return result
}, error => {
  // Message.error(error.message)
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/request/global.js